import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

class UniversalPreloader extends WebComponent {

	constructor(props) {
		super(props);
		const {
			activePreloaders = [],
			lastIsVisible = false
		} = props;
		this.state = {
			activePreloaders,
			lastIsVisible,
		};
	}

	didMount() {
		const {
			visibleClass,
			type,
		} = this.props;

		this.element.classList.add(type);
		this.visibleClass = visibleClass;
	}

	handleOn = (id) => {
		this.startPreloader(id);
	};

	handleOff = (id) => {
		setTimeout(this.endPreloader.bind(null, id), 100);
	};

	startPreloader = (id) => {
		const {
			activePreloaders,
		} = this.state;
		if (activePreloaders.indexOf(id) === -1) {
			activePreloaders.push(id);
			this.refreshHtml();
		}
	};

	endPreloader = (id) => {
		const {
			activePreloaders,
		} = this.state;
		let preloaderIndex = activePreloaders.indexOf(id);
		if (preloaderIndex > -1) {
			activePreloaders.splice(preloaderIndex, 1);
			this.refreshHtml();
		}
	};

	refreshHtml = () => {
		const {
			lastIsVisible,
			activePreloaders,
		} = this.state;
		var isVisible = activePreloaders.length > 0;
		if (isVisible !== lastIsVisible) {
			 this.element.classList.toggle(this.visibleClass);
		}

		this.setState({
			lastIsVisible: isVisible,
		});
	};
}

UniversalPreloader.defaultProps = {
	type: 'snake',
	allowText: false,
	visibleClass: 'visible',
	hideTimout: 200,
	locale: 'cs',
};

export default UniversalPreloader;



// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/UniversalPreloader.js